module.exports = __webpack_public_path__ + "img/Frame 14@2x.f8bc4501.png";